import React from 'react'

import './BtnIcon.css'

export default function BtnIcon({ children, onClick }) {
  return (
    <button className="BtnIcon" type="button" onClick={onClick}>
      {children}
    </button>
  )
}
